import { render } from "./AppSidebar.vue?vue&type=template&id=18e53e93"
import script from "./AppSidebar.vue?vue&type=script&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&lang=ts"

import "./AppSidebar.vue?vue&type=style&index=0&id=18e53e93&lang=scss"
script.render = render

export default script